import { Calculation } from '@servicetitan/financing-api-client';
import { createStore } from '@servicetitan/financing-utils-shared';
import { useState } from 'react';

declare global {
    interface Window {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        __IS_SELECTED_PLAN_STORE_CREATED?: boolean;
        SelectedPlanStore?: any;
    }
}

function useSelectedPlan(initialState: Calculation | null = null) {
    const [selectedPlan, setSelectedPlan] = useState(initialState);
    return { selectedPlan, setSelectedPlan };
}

// if (!window.__IS_SELECTED_PLAN_STORE_CREATED) {
export const SelectedPlanStore = createStore(useSelectedPlan);
// window.__IS_SELECTED_PLAN_STORE_CREATED = true;
// }

// export const SelectedPlanStore = window.SelectedPlanStore;
export type SelectedPlanStoreValue = ReturnType<typeof useSelectedPlan>;
